const omdb_api_key = "d47c4534";
const tmdb_api = "0bcafd5b459497ec53d81e9fc940f86d";
const tmdb_url = `https://api.themoviedb.org/3/movie/550?api_key=0bcafd5b459497ec53d81e9fc940f86d`;
const MoreData = [
	"./images/Tangled.webp",
	"./images/Snowdrop.webp",
	"./images/What-if.webp",
	"./images/Dumbo.webp",
	"./images/Tadap.webp",
	"./images/Snowdrop.webp",
	"./images/GoodDianasour.webp",
	"./images/Hawkeye.webp",
	"./images/Rex.webp",
	"./images/Rudra.webp",
	"./images/SavdhanIndia.webp",
	"./images/Tadap.webp",
	"./images/What-if.webp",
	"./images/GoodDianasour.webp",
];
const Morre = [
	{
		name: "Cuttputlli",
		length: "2 hr 14 min",
		genre: "Mystery, Thriller",
		lang: "Hindi",
		year: 2022,
		details:
			" When a small town gets plunged into the nightmare of serial killings, rookie cop Arjan embarks on a",
	},
];
export default MoreData;
